/* =========================================================
   MEGA MENU — render + interaction
   Reads window.MEGA_MENU_DATA (compact tree: n=name, u=url, t=tag, c=children)
   Works from any Shopify theme's header — no framework required.
   ========================================================= */
(function () {
  "use strict";

  var DATA = window.MEGA_MENU_DATA || [];
  var IMAGES = window.MEGA_MENU_IMAGES || {};
  var root = document.querySelector("[data-mega-menu]");
  if (!root || !DATA.length) return;

  var hoverCapable = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  /* If your theme's header row is taller than the nav trigger itself
     (e.g. a bigger logo pushing the row height up), add
     data-mega-menu-header to that outer header wrapper and the panel
     will align to its bottom edge instead of the button row's. */
  function headerBottom() {
    var boundary = root.closest("[data-mega-menu-header]");
    var ref = boundary || root.querySelector(".mm-bar") || root;
    return Math.round(ref.getBoundingClientRect().bottom);
  }

  /* ---------- helpers ---------- */
  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    attrs = attrs || {};
    for (var k in attrs) {
      if (k === "class") e.className = attrs[k];
      else if (k === "text") e.textContent = attrs[k];
      else e.setAttribute(k, attrs[k]);
    }
    (children || []).forEach(function (c) { if (c) e.appendChild(c); });
    return e;
  }

  function itemLink(node, extraClass) {
    var a = el("a", { class: "mm-item-link " + (extraClass || ""), href: node.u || "#" });
    a.textContent = node.n;
    if (node.t) {
      return el("div", {}, [a, el("span", { class: "mm-tag", text: node.t })]);
    }
    return a;
  }

  function imageFor(url) {
    if (!url) return null;
    var m = url.match(/\/collections\/([^\/?]+)/);
    return m ? IMAGES[m[1]] || null : null;
  }

  /* ============================================================
     DESKTOP: bar + tab panels
     ============================================================ */
  var barInner = el("div", { class: "mm-bar-inner mm-desktop-only", role: "menubar" });
  var panelHost = el("div", { class: "mm-panel-host" });

  DATA.forEach(function (l1, i) {
    var hasChildren = !!(l1.c && l1.c.length);
    var btn = el("button", {
      class: "mm-l1", type: "button",
      "aria-expanded": "false", "aria-controls": "mm-panel-" + i, role: "menuitem"
    });
    var label = document.createElement("span");
    label.textContent = l1.n;
    btn.appendChild(label);
    if (hasChildren) {
      var chev = document.createElement("span");
      chev.className = "mm-l1-chevron";
      chev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
      btn.appendChild(chev);
    }
    barInner.appendChild(btn);

    if (!hasChildren) {
      btn.addEventListener("click", function () { window.location.href = l1.u || "#"; });
      return;
    }

    var panel = buildDesktopPanel(l1, i);
    panel.id = "mm-panel-" + i;
    panelHost.appendChild(panel);

    function openPanel() {
      closeAllPanels();
      panel.style.top = headerBottom() + "px";
      panel.classList.add("is-open");
      btn.setAttribute("aria-expanded", "true");
    }
    function closeThis() {
      panel.classList.remove("is-open");
      btn.setAttribute("aria-expanded", "false");
    }

    btn.addEventListener("click", function () {
      var isOpen = panel.classList.contains("is-open");
      isOpen ? closeThis() : openPanel();
    });

    if (hoverCapable) {
      var enterTimer, leaveTimer;
      var group = el("div"); // no-op wrapper not needed; use li hover via btn+panel
      btn.addEventListener("mouseenter", function () {
        clearTimeout(leaveTimer);
        enterTimer = setTimeout(openPanel, 90);
      });
      btn.addEventListener("mouseleave", function () {
        clearTimeout(enterTimer);
        leaveTimer = setTimeout(function () {
          if (!panel.matches(":hover")) closeThis();
        }, 220);
      });
      panel.addEventListener("mouseenter", function () { clearTimeout(leaveTimer); });
      panel.addEventListener("mouseleave", function () {
        leaveTimer = setTimeout(closeThis, 180);
      });
    }
  });

  function closeAllPanels() {
    panelHost.querySelectorAll(".mm-panel.is-open").forEach(function (p) { p.classList.remove("is-open"); });
    barInner.querySelectorAll('.mm-l1[aria-expanded="true"]').forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
  }

  function buildFlatCard(node, showButton) {
    var img = imageFor(node.u);
    var tag = showButton ? "div" : "a";
    var cardAttrs = { class: "mm-flat-card" + (img ? " has-image" : "") };
    if (!showButton) cardAttrs.href = node.u || "#";
    var card = el(tag, cardAttrs);
    if (img) {
      var imgWrap = showButton
        ? el("a", { class: "mm-flat-card-img", href: node.u || "#" }, [el("img", { src: img, alt: node.n, loading: "lazy" })])
        : el("div", { class: "mm-flat-card-img" }, [el("img", { src: img, alt: node.n, loading: "lazy" })]);
      card.appendChild(imgWrap);
    }
    var bodyChildren = showButton
      ? [
          el("a", { class: "mm-flat-card-name", href: node.u || "#", text: node.n }),
          el("a", { class: "mm-flat-card-cta", href: node.u || "#", text: "Shop now" })
        ]
      : [el("span", { class: "mm-flat-card-name", text: node.n })];
    card.appendChild(el("div", { class: "mm-flat-card-body" }, bodyChildren));
    return card;
  }

  function buildDesktopPanel(l1, i) {
    var allLeaf = l1.c.every(function (l2) { return !(l2.c && l2.c.length); });

    if (allLeaf) {
      // Every L2 here is a dead end (no L3+) — tabs would force one item
      // at a time for no reason. Show them all at once as a flat grid.
      var flatWrap = el("div", { class: "mm-shelves-wrap mm-flat-wrap" });
      var flatGrid = el("div", { class: "mm-flat-grid" });
      l1.c.forEach(function (l2) { flatGrid.appendChild(buildFlatCard(l2, false)); });
      flatWrap.appendChild(flatGrid);
      var soloGrid = el("div", { class: "mm-panel-grid mm-panel-grid--flat" }, [flatWrap]);
      return el("div", { class: "mm-panel" }, [soloGrid]);
    }

    var rail = el("div", { class: "mm-rail" });
    var railList = el("ul", { class: "mm-rail-list", role: "tablist" });
    var shelvesWrap = el("div", { class: "mm-shelves-wrap" });

    l1.c.forEach(function (l2, j) {
      var tabBtn = el("button", { class: "mm-tab", type: "button", role: "tab", "aria-selected": j === 0 ? "true" : "false" });
      tabBtn.textContent = l2.n;
      railList.appendChild(el("li", {}, [tabBtn]));

      var shelves = el("div", { class: "mm-shelves" + (j === 0 ? " is-active" : "") });
      shelves.appendChild(buildShelvesContent(l2));
      shelvesWrap.appendChild(shelves);

      tabBtn.addEventListener("click", function () {
        railList.querySelectorAll(".mm-tab").forEach(function (b) { b.setAttribute("aria-selected", "false"); });
        shelvesWrap.querySelectorAll(".mm-shelves").forEach(function (s) { s.classList.remove("is-active"); });
        tabBtn.setAttribute("aria-selected", "true");
        shelves.classList.add("is-active");
      });
    });

    rail.appendChild(railList);
    if (l1.u) {
      rail.appendChild(el("a", { class: "mm-rail-all", href: l1.u }, [
        (function () { var s = document.createElement("span"); s.textContent = "Shop all " + l1.n; return s; })()
      ]));
    }

    var grid = el("div", { class: "mm-panel-grid" }, [rail, shelvesWrap]);
    return el("div", { class: "mm-panel" }, [grid]);
  }

  function buildL3Row(l3) {
    var img = imageFor(l3.u);
    var row = el("a", { class: "mm-l3-row", href: l3.u || "#" });
    if (img) {
      row.appendChild(el("div", { class: "mm-l3-row-img" }, [
        el("img", { src: img, alt: l3.n, loading: "lazy" })
      ]));
    }
    row.appendChild(el("span", { class: "mm-l3-row-name", text: l3.n }));
    row.appendChild(el("span", { class: "mm-l3-row-arrow", text: "\u2192" }));
    return row;
  }

  function buildShelvesContent(l2) {
    var hasChildren = !!(l2.c && l2.c.length);
    if (!hasChildren) {
      var soloWrap = el("div", { class: "mm-flat-grid mm-flat-grid--solo" });
      soloWrap.appendChild(buildFlatCard(l2, true));
      return soloWrap;
    }
    // Spec caps every L2 at a max of 4 L3 items (one of which may be a
    // "More" item). The 4-item list is compact and leaves a lot of the
    // panel empty — if that "More" item has facet children (real
    // sub-categories with their own URLs), show them alongside as a
    // second list instead of leaving that space empty.
    var moreItem = null;
    l2.c.forEach(function (l3) { if (l3.n === "More" && l3.c && l3.c.length) moreItem = l3; });

    var wrap = el("div", { class: "mm-l3-wrap" + (moreItem ? " has-more" : "") });
    var list = el("div", { class: "mm-l3-list" });
    l2.c.forEach(function (l3) {
      // Skip "More" itself in the main list once its facets are already
      // shown as their own column — the row would just duplicate what's
      // right there next to it.
      if (l3 === moreItem) return;
      list.appendChild(buildL3Row(l3));
    });
    wrap.appendChild(list);

    if (moreItem) {
      var moreCol = el("div", { class: "mm-l3-more" });
      var moreList = el("div", { class: "mm-l3-list" });
      moreItem.c.forEach(function (item) { moreList.appendChild(buildL3Row(item)); });
      moreCol.appendChild(moreList);
      wrap.appendChild(moreCol);
    }

    return wrap;
  }

  /* ============================================================
     MOBILE: hamburger + off-canvas accordion
     ============================================================ */
  var burger = el("button", { class: "mm-burger", type: "button", "aria-label": "Open menu", "aria-expanded": "false" });
  burger.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';

  var overlay = el("div", { class: "mm-drawer-overlay" });
  var drawer = el("div", { class: "mm-drawer", role: "dialog", "aria-label": "Site menu" });
  var drawerHead = el("div", { class: "mm-drawer-head" }, [
    el("span", { text: "Menu" }),
    (function () {
      var b = el("button", { class: "mm-drawer-close", type: "button", "aria-label": "Close menu" });
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>';
      return b;
    })()
  ]);
  var accRoot = el("ul", { class: "mm-acc" });
  DATA.forEach(function (l1) { accRoot.appendChild(buildAccordionNode(l1, 1)); });
  drawer.appendChild(drawerHead);
  drawer.appendChild(accRoot);

  function buildAccordionNode(node, depth) {
    var hasChildren = !!(node.c && node.c.length);
    var li = el("li", { class: "mm-acc-item mm-depth-" + depth });

    if (!hasChildren) {
      li.appendChild(el("div", { class: "mm-acc-link-row" }, [itemLink(node)]));
      return li;
    }

    var btn = el("button", { class: "mm-acc-btn", type: "button", "aria-expanded": "false" });
    var label = document.createElement("span");
    label.textContent = node.n;
    var chevron = document.createElement("span");
    chevron.className = "mm-chevron";
    chevron.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 6 15 12 9 18"/></svg>';
    btn.appendChild(label);
    btn.appendChild(chevron);

    var sub = el("div", { class: "mm-acc-panel" });
    if (node.u) {
      var shopAll = el("a", { class: "mm-item-link mm-shop-all", href: node.u, text: "Shop all " + node.n });
      sub.appendChild(el("div", {}, [shopAll]));
    }
    var subList = el("ul", { class: "mm-acc" });
    node.c.forEach(function (child) { subList.appendChild(buildAccordionNode(child, depth + 1)); });
    sub.appendChild(subList);

    btn.addEventListener("click", function () {
      var open = sub.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });

    li.appendChild(btn);
    li.appendChild(sub);
    return li;
  }

  function openDrawer() {
    overlay.classList.add("is-open");
    drawer.classList.add("is-open");
    burger.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    overlay.classList.remove("is-open");
    drawer.classList.remove("is-open");
    burger.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }
  burger.addEventListener("click", openDrawer);
  overlay.addEventListener("click", closeDrawer);
  drawerHead.querySelector(".mm-drawer-close").addEventListener("click", closeDrawer);

  /* ---------- assemble ---------- */
  var bar = el("div", { class: "mm-bar" }, [barInner, burger]);
  root.appendChild(bar);
  // panels, overlay, and drawer attach to <body> directly — NOT inside
  // root. root sits inside the theme's header grid, which may be small,
  // absolutely positioned, or overflow-clipped; a fixed-position overlay
  // nested inside that is fragile and can get visually clipped or land
  // behind other stacked elements. Attaching to body sidesteps all of
  // that regardless of the surrounding theme markup.
  document.body.appendChild(panelHost);
  document.body.appendChild(overlay);
  document.body.appendChild(drawer);

  document.addEventListener("click", function (e) {
    if (!root.contains(e.target) && !panelHost.contains(e.target) && !drawer.contains(e.target)) {
      closeAllPanels();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeAllPanels(); closeDrawer(); }
  });

  /* ============================================================
     Mobile hamburger clearance — measured, not guessed
     .header__inline-menu is pinned to the header's left edge via CSS
     (position: absolute; left: 0) whenever the mobile burger row is
     active. The logo needs enough left margin to not overlap it, but a
     fixed CSS number only holds at the widths it was tested against —
     Dawn's own internal breakpoints (e.g. around 750px, independent of
     ours) can change how the header renders in between, which is
     exactly what broke this at iPad-range widths. Measuring the
     hamburger's actual rendered size at runtime and applying that
     directly to the logo removes the guesswork entirely.
     ============================================================ */
  var MOBILE_BREAKPOINT = 1279;
  function positionMobileNav() {
    var navMenu = document.querySelector(".header__inline-menu");
    var header = document.querySelector("[data-mega-menu-header]");
    if (!navMenu || !header) return;
    var logoLink = header.querySelector(".header__heading-link");
    var isMobileNav = window.innerWidth <= MOBILE_BREAKPOINT;

    if (!isMobileNav) {
      // Desktop — clear any inline overrides so normal CSS/grid layout applies.
      ["position", "left", "top", "transform", "display", "width", "z-index"].forEach(function (prop) {
        navMenu.style.removeProperty(prop);
      });
      if (logoLink) logoLink.style.removeProperty("margin-left");
      return;
    }

    // Mobile/tablet — set directly via JS with !important. This is the
    // highest-priority style possible in CSS; nothing in Dawn's own
    // stylesheet, at any of its own internal breakpoints, can outrank it.
    navMenu.style.setProperty("display", "block", "important");
    navMenu.style.setProperty("position", "absolute", "important");
    navMenu.style.setProperty("left", "0px", "important");
    navMenu.style.setProperty("top", "50%", "important");
    navMenu.style.setProperty("transform", "translateY(-50%)", "important");
    navMenu.style.setProperty("width", "auto", "important");
    navMenu.style.setProperty("z-index", "2", "important");
    header.style.setProperty("position", "relative", "important");
  }
  window.addEventListener("load", positionMobileNav);
  window.addEventListener("resize", positionMobileNav);
  setTimeout(positionMobileNav, 300); // catch late logo image load
})();